import { DocumentFormat, RichEditUnit } from 'devexpress-richedit';

export const richEditorSetting = {
  width: '100%',
  height: '100%',
  units: RichEditUnit.Centimeter,
  format: DocumentFormat.Html,
};
